import { render } from "./InfoIcon.vue?vue&type=template&id=01b2bdb9&ts=true"
import script from "./InfoIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/InfoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01b2bdb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01b2bdb9', __exports__)) {
    api.reload('01b2bdb9', __exports__)
  }
  
  module.hot.accept("./InfoIcon.vue?vue&type=template&id=01b2bdb9&ts=true", () => {
    api.rerender('01b2bdb9', render)
  })

}


export default __exports__